import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';

export function IconBigPlayButton({ classProps }: PropsWithClassProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      className={classProps?.root}
    >
      <g filter="url(#filter0_b_9061_136695)">
        <rect x="1" y="1" width="48" height="48" rx="24" fill="#181818" fillOpacity="0.7" />
        <rect x="1" y="1" width="48" height="48" rx="24" stroke="#545458" strokeOpacity="0.65" />
        <path
          d="M18.5 18.09C18.5 17.1328 18.5 16.6541 18.7139 16.3903C18.9003 16.1604 19.1852 16.0182 19.4936 16.001C19.8476 15.9813 20.2744 16.2468 21.1282 16.7778L32.2383 23.6878C32.9438 24.1265 33.2965 24.3459 33.4194 24.6224C33.5269 24.8642 33.5269 25.1358 33.4194 25.3776C33.2965 25.6541 32.9438 25.8735 32.2383 26.3122L21.1282 33.2222C20.2744 33.7532 19.8476 34.0187 19.4936 33.999C19.1852 33.9818 18.9003 33.8396 18.7139 33.6097C18.5 33.3459 18.5 32.8672 18.5 31.91V18.09Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_9061_136695"
          x="-23.5"
          y="-23.5"
          width="97"
          height="97"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_9061_136695" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_9061_136695" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
